import { styled } from "styled-components";

import { UIButton } from "common/components";

export const Container = styled.div<{ error: boolean }>`
  position: relative;
  aspect-ratio: 1 / 1;
  display: block;
  width: 15rem;

  &::after {
    border: 2px solid ${({ error, theme }) => (error ? theme.colors.error : "rgba(0, 0, 0, 0.5)")};
    border-radius: 5px;
    box-shadow: inset 0 0 0 1000px rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
    content: "";
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
  }
`;

export const Image = styled.img`
  border-radius: 5px;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

export const Button = styled(UIButton)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.white};
  outline: ${({ error, theme }) => (error ? `2px solid ${theme.colors.error}` : "none")};
  z-index: 1;

  &:focus-visible,
  &:hover {
    border-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.white};
  }
`;
